import React, { useContext, useState } from 'react';
import { clone, cloneDeep } from 'lodash';

import { RestApiContext } from '../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [pageIsReady, setPageIsReady] = useState(false);
    const [state, setState] = useAggregatedState({
        errors: null
    });

    const apiClient = useContext(RestApiContext);

    const loginAsync = async ({ email, fiscalCode, bookingCode }) => {
        try {
            setState({ errors: null });
            const accessToken = await apiClient.loginAsync({ email, fiscalCode, bookingCode });
            return true;
        } catch (e) {
            console.debug(e);
            setState({ errors: e.details });
            return false;
        }
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            loginAsync
        }}>
            {props.children}
        </Provider>
    );
}